import { ReactElement } from 'react';
import { ReactComponent as Flag } from 'src/assets/flag.svg';
import {ReactComponent as InternationalFlag} from 'src/assets/bangladeshFlag.svg'
import { blurOnScroll } from 'src/utils/generic';
import { UNICODE } from 'src/constants';

interface InputBoxprops {
  handleChange: (e?: Record<string, any>) => void;
  onKeyDown?: any;
  inputNumber: string;
  customeWidth?: string;
}



const InputBox = ({ handleChange, inputNumber,customeWidth,onKeyDown }: InputBoxprops): ReactElement => {
  let isError = inputNumber?.length > 10 ? true : false;
  const isInternational =Boolean(Number(localStorage.getItem('isInternational')));
  return (
    <div className={`${customeWidth ? customeWidth : 'w-10/12'}`}>
      <div className="border rounded-lg bg-white focus:outline-none focus:border-blue flex flex-row">
        <div className="object-fill">
          {!isInternational ? (
            <Flag className="rounded-l-lg" />
          ) : (
            <InternationalFlag className="rounded-l-lg" />
          )}
        </div>
        <div className="h-flagh flex p-3 ">
          {`+${!isInternational ? UNICODE.India : UNICODE.Bangladesh}`}
        </div>
        <input
          className="h-flagh w-7/12 px-1 text-700 leading-tight focus:outline-none focus:border-blue"
          onChange={handleChange}
          onKeyDown={onKeyDown}
          value={inputNumber}
          type="number"
          placeholder={'Mobile Number'}
          onWheel={blurOnScroll}
        />
      </div>
      {isError && (
        <p className="text-red-600 text-sm text-left pt-2">
          Please verify and enter a valid mobile number
        </p>
      )}
    </div>
  );
};

export default InputBox;
